export const environment = {
  production: true,
  // apiUrl: 'http://localhost:3006/api'
  apiUrl: 'https://api.chipo.blexta.co.zw/api'
};
